export default __webpack_public_path__ + "static/media/i007hp.488cf937.webp";